import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  className?: string;
  as?: "h1" | "h2" | "h3";
  tone?: "auto" | "light" | "dark";
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  className,
  as: Tag = "h2",
  tone = "auto",
}: SectionHeadingProps) {
  return (
    <div
      data-component="section-heading"
      data-tone={tone}
      className={cn(
        "public-section-heading max-w-3xl",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      {eyebrow && (
        <div className="public-section-heading__eyebrow mb-5 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
          <span className="h-px w-8 bg-foreground/40" aria-hidden="true" />
          {eyebrow}
        </div>
      )}
      <Tag className="public-section-heading__title font-display text-balance text-4xl font-semibold leading-[1.05] tracking-tight text-foreground sm:text-5xl md:text-6xl">
        {title}
      </Tag>
      {description && (
        <p className="public-section-heading__description mt-6 text-pretty text-lg leading-relaxed text-muted-foreground sm:text-xl">
          {description}
        </p>
      )}
    </div>
  );
}
